const DEFAULT_DURATION = 2200;
const FADE_OUT_MS = 200;

class SiteToast extends HTMLElement {
  connectedCallback() {
    this._hideTimeoutId = null;
    this._removeTimeoutId = null;
    window.LenszaToast = { show: (message, options) => this.show(message, options) };
  }

  show(message, { duration = DEFAULT_DURATION } = {}) {
    if (!message) return;

    clearTimeout(this._hideTimeoutId);
    clearTimeout(this._removeTimeoutId);

    this.innerHTML = `<div class="site-toast__message">${this._escapeHtml(message)}</div>`;

    // Promotes the toast into the top layer, the same rendering layer
    // #DialogModal enters via showModal() — without this the toast would
    // render underneath an open dialog no matter its z-index.
    this._openPopover();

    // Add the visibility class on the next frame so the initial (hidden) state
    // actually paints first — otherwise the browser coalesces both style
    // changes into one frame and the fade-in transition never runs.
    requestAnimationFrame(() => {
      const el = this.querySelector('.site-toast__message');
      if (el) el.classList.add('is-visible');
    });

    this._hideTimeoutId = setTimeout(() => this._hide(), duration);
  }

  _hide() {
    const el = this.querySelector('.site-toast__message');
    if (!el) return;

    el.classList.remove('is-visible');
    this._removeTimeoutId = setTimeout(() => {
      if (this.querySelector('.site-toast__message') === el) this.innerHTML = '';
      this._closePopover();
    }, FADE_OUT_MS);
  }

  // Popover API isn't universal — browsers without it just keep the toast as
  // a plain fixed element (fine whenever no top-layer dialog is open, which
  // is the common case; it just won't out-rank an open dialog there).
  _openPopover() {
    if (typeof this.showPopover !== 'function') return;
    try {
      this.showPopover();
    } catch {
      // already open
    }
  }

  _closePopover() {
    if (typeof this.hidePopover !== 'function') return;
    try {
      this.hidePopover();
    } catch {
      // already closed
    }
  }

  _escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = String(value ?? '');
    return div.innerHTML;
  }
}

if (!customElements.get('site-toast')) {
  customElements.define('site-toast', SiteToast);
}
